import RoleHome from '../../components/RoleHome/RoleHome';
export default function StorekeeperHome() {
  return <RoleHome role="storekeeper" />;
}